import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { modaleAvviso } from '../_modal/modale-avviso/modale-avviso.component';
import { ToastService } from '../_services/toast.service';
import { modaleErrore } from '../_modal/modale-errore/modale-errore.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		private modalService: NgbModal,
		private authService: AuthService,
		private toastService: ToastService,
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error instanceof HttpErrorResponse) {
					/* Esclusuioni */
					if (request.url.includes('/people') && request.method === 'PUT' && (request.body as any).password) {
						return throwError(() => error);
					} // Servizio di cambio password

					/* gestione dell' errore nella response */
					if (error.status === 401) {
						// Sessione scaduta
						this.modalService.dismissAll();
						modaleAvviso(this.modalService, "La sessione é scaduta, effettuare nuovamente l'accesso.");
						this.authService.logout();
					} else if (error.status === 403 && !request.url.endsWith('tickets')) {
						this.modalService.dismissAll();
						modaleAvviso(this.modalService, 'Attenzione, si sta provando ad accedere ad una funzionalità di cui non si ha autorizzazione.');
					} else if (error.status === 403 && request.url.endsWith('tickets')) {
						this.toastService.showError('Le credenziali inserite non sono valide.');
					} else if (error.status === 404 && request.url.endsWith('dataLists')) {
						console.warn('Questo sito non ha nessuna datalist configurata');
					} else {
						modaleErrore(this.modalService, 'Si è verificato un errore.', error);
					}
				}
				return throwError(() => error);
			}),
		);
	}
}
